<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 19:01:20
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-02-09 12:00:00
 * @Description: 创建菜单下拉选择组件
 * @FilePath: /weryai-web/components/ui/SelectCreateMenu.vue
-->
<template>
    <div ref="triggerRef" class="select-create-menu-wrapper" @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave">
        <div ref="titleRef" class="cursor-pointer flex items-center gap-2" :class='setClass'>
            <!-- 标题文字 -->
            <span v-if="title" class="menu-title">{{ title }}</span>
            <!-- 下拉指示器图标 -->
            <span class="flex items-center justify-center text-white transition-all duration-300"
                :class="showMenu ? 'rotate-0' : 'rotate-180'">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                    <path
                        d="M3.99317 3.49997e-07C3.81817 3.65296e-07 3.64317 0.0500006 3.51817 0.175001L0.268171 2.925C-0.0568292 3.2 -0.0818307 3.675 0.16817 3.975C0.44317 4.3 0.91817 4.325 1.21817 4.075L3.99317 1.725L6.76817 4.075C7.09317 4.35 7.56817 4.3 7.81817 3.975C8.09317 3.65 8.04317 3.175 7.71817 2.925L4.46817 0.175C4.34317 0.0500005 4.16817 3.34698e-07 3.99317 3.49997e-07Z"
                        fill="white" />
                </svg>
            </span>
        </div>


        <!-- 下拉菜单 - 使用 Teleport 悬浮在最上层 -->
        <Teleport to="body">
            <Transition name="menu-fade">
                <div v-if="showMenu" :key="currentPath" class="menu-dropdown-fixed" :style="menuPosition"
                    @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                    <div class="menu-content">
                        <!-- 图片分类 -->
                        <div class="menu-section">
                            <h3 class="section-title">{{ t('menus.createModal.image') }}</h3>
                            <div class="menu-grid">
                                <template v-for="item in imageMenuItems" :key="item.path">
                                    <NuxtLink v-if="!item.isModal" :to="item.path" class="menu-item"
                                        :class="{ 'menu-item--active': isActive(item.no_lang_path, 'image') }"
                                        @click="closeMenu">
                                        <span class="menu-icon" :class="item.icon"></span>
                                        <span class="menu-text">{{ item.name }}</span>
                                        <span v-if="isActive(item.no_lang_path, 'image')" class="menu-check">
                                            <svg class="w-4 h-4 text-[#99F768]" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2.5">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                        </span>
                                    </NuxtLink>
                                    <button v-else type="button" class="menu-item"
                                        :class="{ 'menu-item--active': isActive(item.no_lang_path, 'image') }"
                                        @click="handleImageModalItem(item)">
                                        <span class="menu-icon" :class="item.icon"></span>
                                        <span class="menu-text">{{ item.name }}</span>
                                        <span v-if="isActive(item.no_lang_path, 'image')" class="menu-check">
                                            <svg class="w-4 h-4 text-[#99F768]" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2.5">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                        </span>
                                    </button>
                                </template>
                            </div>
                        </div>

                        <!-- 视频分类 -->
                        <div class="menu-section">
                            <h3 class="section-title">{{ t('menus.createModal.video') }}</h3>
                            <div class="menu-grid">
                                <template v-for="item in videoMenuItems" :key="item.path">
                                    <NuxtLink v-if="!item.isModal" :to="item.path" class="menu-item"
                                        :class="{ 'menu-item--active': isActive(item.no_lang_path, 'video') }"
                                        @click="closeMenu">
                                        <span class="menu-icon" :class="item.icon"></span>
                                        <span class="menu-text">{{ item.name }}</span>
                                        <span v-if="isActive(item.no_lang_path, 'video')" class="menu-check">
                                            <svg class="w-4 h-4 text-[#99F768]" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2.5">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                        </span>
                                    </NuxtLink>
                                    <button v-else type="button" class="menu-item"
                                        :class="{ 'menu-item--active': isActive(item.no_lang_path, 'video') }"
                                        @click="handleVideoModalItem(item)">
                                        <span class="menu-icon" :class="item.icon"></span>
                                        <span class="menu-text">{{ item.name }}</span>
                                        <span v-if="isActive(item.no_lang_path, 'video')" class="menu-check">
                                            <svg class="w-4 h-4 text-[#99F768]" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2.5">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                        </span>
                                    </button>
                                </template>
                            </div>
                        </div>

                        <!-- 音乐分类 -->
                        <div class="menu-section menu-section--last">
                            <h3 class="section-title">{{ t('menus.createModal.music') }}</h3>
                            <div class="menu-grid">
                                <NuxtLink v-for="item in musicMenuItems" :key="item.path" :to="item.path"
                                    class="menu-item" :class="{ 'menu-item--active': isActive(item.no_lang_path) }"
                                    @click="closeMenu">
                                    <span class="menu-icon" :class="item.icon"></span>
                                    <span class="menu-text">{{ item.name }}</span>
                                    <span v-if="isActive(item.no_lang_path)" class="menu-check">
                                        <svg class="w-4 h-4 text-[#99F768]" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2.5">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                    </span>
                                </NuxtLink>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
        </Teleport>

        <chat-creation-tools-select-modal v-model:visible="showImageToolsModal" v-model="selectedImageToolPath"
            :type="toolsModalType" @confirm="handleImageToolsConfirm"></chat-creation-tools-select-modal>
        <chat-creation-template-select-modal v-model:visible="showTemplateModal" v-model="selectedTemplateId"
            :type="templateModalType" @confirm="handleTemplateConfirm"></chat-creation-template-select-modal>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, onDeactivated, watch, nextTick } from 'vue'
import { useI18n } from '~/composables/useI18n'
import { deleteLangPrefix } from '@/utils/common'
import { emitOpenPromptReversalModal } from '@/utils/emitter'
import { useToolsHooks } from '@/utils/useHooks'

const { aiVideoToolsEnums, aiImageToolsEnums } = useToolsHooks()
const props = withDefaults(
    defineProps<{
        title?: string
        setClass?: string
    }>(),
    {
        title: '',
        setClass: 'mb-[30px]'
    }
)

const route = useRoute()
const appStore = useAppStore()
const { t, locale } = useI18n()
const hiddenCharacterPaths = new Set([
    '/characters',
    '/character-to-image',
    '/character-to-video'
])

// 触发区域的 ref
const triggerRef = ref<HTMLElement | null>(null)
// 标题区域的 ref（用于菜单定位）
const titleRef = ref<HTMLElement | null>(null)

// 菜单位置
const menuPosition = ref({ top: '0px', left: '0px' })

// 内部控制菜单显示状态
const showMenu = ref(false)
const showImageToolsModal = ref(false)
const selectedImageToolPath = ref<string | null>(null)
const toolsModalType = ref<'IMAGE' | 'VIDEO'>('IMAGE')
const showTemplateModal = ref(false)
const selectedTemplateId = ref<number | null>(null)
const templateModalType = ref<'IMAGE' | 'VIDEO'>('IMAGE')

// hover 定时器
let hoverTimer: ReturnType<typeof setTimeout> | null = null

// 鼠标进入
const handleMouseEnter = () => {
    if (hoverTimer) {
        clearTimeout(hoverTimer)
        hoverTimer = null
    }
    // 先计算位置，再显示菜单，避免从左上角移入
    updateMenuPosition()
    showMenu.value = true
}

// 鼠标离开（延迟关闭）
const handleMouseLeave = () => {
    if (hoverTimer) {
        clearTimeout(hoverTimer)
    }
    hoverTimer = setTimeout(() => {
        showMenu.value = false
        hoverTimer = null
    }, 150)
}

// 计算菜单位置 - 和标题区域左对齐
const updateMenuPosition = () => {
    if (!titleRef.value) return

    const rect = titleRef.value.getBoundingClientRect()
    menuPosition.value = {
        top: `${rect.bottom + 4}px`, // 在标题区域下方 4px
        left: `${rect.left}px` // 与标题区域左对齐
    }
}

// 监听 showMenu 变化，更新位置
watch(showMenu, (val) => {
    if (val) {
        nextTick(() => {
            updateMenuPosition()
        })
    }
})

// === 路径格式化函数 ===
const formatPath = (rawPath: string) => {
    if (!rawPath) return rawPath

    if (/^(https?:)?\/\//.test(rawPath) || rawPath.startsWith('#')) {
        return rawPath
    }

    const pathMatch = rawPath.match(/^[^?#]*/)
    const pathname = pathMatch ? pathMatch[0] : rawPath
    const suffix = rawPath.slice(pathname.length)

    const withLeadingSlash = pathname.startsWith('/') ? pathname : `/${pathname}`
    const sanitized = withLeadingSlash.replace(/^\/([a-z]{2})(?=\/|$)/i, '/')
    const cleanedPath = sanitized.replace(/\/+/g, '/').replace(/\/$/, '')

    const currentLocale = locale?.value || 'en'
    const normalizedSuffix = suffix.replace(/\/+/g, '/')

    if (currentLocale === 'en') {
        return `${cleanedPath || '/'}${normalizedSuffix}`
    }

    const prefix = `/${currentLocale}`
    if (!cleanedPath || cleanedPath === '/') {
        return `${prefix}${normalizedSuffix}`
    }

    return `${prefix}${cleanedPath}${normalizedSuffix}`
}

// === 菜单数据定义 ===

// 图片工具菜单
const imageMenuItems = computed(() => {
    const items = [
        {
            path: formatPath('/text-to-image'),
            no_lang_path: '/text-to-image',
            name: t('menus.textToImage'),
            icon: 'i-select-txt-img',
        },
        {
            path: formatPath('/image-to-image'),
            no_lang_path: '/image-to-image',
            name: t('menus.imageToImage'),
            icon: 'i-select-img-img',
        },
        {
            path: formatPath('/character-to-image'),
            no_lang_path: '/character-to-image',
            name: t('characterToImg.characterToImage'),
            icon: 'i-select-char-vid',
        },
        {
            path: formatPath('/ai-tools'),
            no_lang_path: '/ai-tools',
            name: t('menus.AITools'),
            icon: 'i-select-edit-tool',
            isModal: true,
            modalType: 'TOOLS',
        },
        {
            path: formatPath('/photo-effects'),
            no_lang_path: '/photo-effects',
            name: t('menus.photoEffects'),
            icon: 'i-select-img-temp',
            isModal: true,
            modalType: 'TEMPLATE',
        },
    ]

    if (!appStore.hideCharacterEntries) {
        return items
    }

    return items.filter(item => !hiddenCharacterPaths.has(item.no_lang_path))
})

// 视频工具菜单
const videoMenuItems = computed(() => {
    const items = [
        {
            path: formatPath('/text-to-video'),
            no_lang_path: '/text-to-video',
            name: t('menus.textToVideo'),
            icon: 'i-select-txt-vid',
            isModal: false,
        },
        {
            path: formatPath('/image-to-video'),
            no_lang_path: '/image-to-video',
            name: t('menus.imageToVideo'),
            icon: 'i-select-img-vid',
            isModal: false,
        },
        {
            path: formatPath('/character-to-video'),
            no_lang_path: '/character-to-video',
            name: t('characterToImg.characterToVideo'),
            icon: 'i-select-char-vid',
            isModal: false,
        },
        {
            path: formatPath('/video-to-video'),
            no_lang_path: '/video-to-video',
            name: t('menus.videoToVideo'),
            icon: 'i-select-vid-edit',
            isModal: false,
        },
        {
            path: formatPath('/ai-tools'),
            no_lang_path: '/ai-tools',
            name: t('menus.AITools'),
            icon: 'i-select-edit-tool',
            isModal: true,
            modalType: 'TOOLS',
        },
        {
            path: formatPath('/video-effects'),
            no_lang_path: '/video-effects',
            name: t('menus.videoEffects'),
            icon: 'i-select-vid-temp',
            isModal: true,
            modalType: 'TEMPLATE',
        },
    ]

    if (!appStore.hideCharacterEntries) {
        return items
    }

    return items.filter(item => !hiddenCharacterPaths.has(item.no_lang_path))
})

// 音乐工具菜单
const musicMenuItems = computed(() => [
    { path: formatPath('/text-to-music'), no_lang_path: '/text-to-music', name: t('menus.generateMusic'), icon: 'i-generate-music-icon' },

])

// === 交互方法 ===

const closeMenu = () => {
    showMenu.value = false
}

const handleImageModalItem = (item: any) => {
    if (!item?.isModal) return
    closeMenu()
    if (item.modalType === 'TEMPLATE') {
        templateModalType.value = 'IMAGE'
        selectedTemplateId.value = null
        showTemplateModal.value = true
        return
    }

    toolsModalType.value = 'IMAGE'
    selectedImageToolPath.value = null
    showImageToolsModal.value = true
}

const handleVideoModalItem = (item: any) => {
    if (!item?.isModal) return
    closeMenu()
    if (item.modalType === 'TEMPLATE') {
        templateModalType.value = 'VIDEO'
        selectedTemplateId.value = null
        showTemplateModal.value = true
        return
    }

    toolsModalType.value = 'VIDEO'
    selectedImageToolPath.value = null
    showImageToolsModal.value = true
}

const handleImageToolsConfirm = (tool: any) => {
    if (!tool) return

    if (tool.isModal) {
        emitOpenPromptReversalModal()
        return
    }

    if (tool.path) {
        navigateTo(tool.path)
    }
}

const handleTemplateConfirm = (data: any) => {
    const slug = data?.template?.path_url
    if (!slug || typeof slug !== 'string') return

    const base = templateModalType.value === 'VIDEO' ? '/video-effects' : '/photo-effects'
    navigateTo(formatPath(`${base}/${slug}`))
}

const normalizeNoLangPath = (path: string) => {
    if (!path) return '/'
    const noLangPath = deleteLangPrefix(path)
    const withoutQuery = noLangPath.split('?')[0]?.split('#')[0] || '/'
    if (withoutQuery === '/') return '/'
    return withoutQuery.replace(/\/+$/, '')
}

// 当前路径：chat 页面时从 store 读取工具路径（CreationSettingsDrawer 写入），否则用 route.path
const currentPath = computed(() => {
    if (appStore.chatCreationToolPath) {
        return normalizeNoLangPath(appStore.chatCreationToolPath)
    }
    return normalizeNoLangPath(route.path)
})

const isCurrentImageAiTool = computed(() => {
    return aiImageToolsEnums.value.some((item: any) => normalizeNoLangPath(item.path) === currentPath.value)
})

const isCurrentVideoAiTool = computed(() => {
    return aiVideoToolsEnums.value.some((item: any) => normalizeNoLangPath(item.path) === currentPath.value)
})

const isActive = (noLangPath: string, category?: 'image' | 'video' | 'music') => {
    const normalizedItemPath = normalizeNoLangPath(noLangPath)

    // /ai-tools 在图片、视频分类里各有一个入口，这里按当前工具类型只高亮对应分类的入口
    if (normalizedItemPath === '/ai-tools') {
        if (isCurrentImageAiTool.value || isCurrentVideoAiTool.value) {
            if (category === 'image') return isCurrentImageAiTool.value
            if (category === 'video') return isCurrentVideoAiTool.value
            return false
        }
    }

    return currentPath.value === normalizedItemPath || currentPath.value.startsWith(`${normalizedItemPath}/`)
}

const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
        closeMenu()
    }
}

watch(() => route.path, (newVal) => {
    if (newVal) {
        showMenu.value = false
        appStore.setToolSidebarOpen(false)
    }
})

onMounted(() => {
    document.addEventListener('keydown', handleKeydown)
})

onDeactivated(() => {
    showMenu.value = false
})

onUnmounted(() => {
    document.removeEventListener('keydown', handleKeydown)
})
</script>

<style scoped lang="less">
// 包装器 - 用于统一处理 hover 事件
.select-create-menu-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

// 标题文字
.menu-title {
    color: #fff;
    font-size: inherit;
    font-weight: inherit;
    white-space: nowrap;
}

// 下拉菜单容器 - fixed 定位悬浮在最上层
.menu-dropdown-fixed {
    position: fixed;
    z-index: 99999;
}

// 菜单内容
.menu-content {
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.10);
    background: #1C1C20;
    box-shadow: 0 20px 60px 0 rgba(0, 0, 0, 0.50);
    padding: 10px;
}

// 菜单淡入淡出动画
.menu-fade-enter-active,
.menu-fade-leave-active {
    transition: all 0.15s ease;
}

.menu-fade-enter-from,
.menu-fade-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}

// 触发按钮旋转样式
.rotate-180 {
    transform: rotate(180deg);
}

// 分区样式
.menu-section {
    margin-bottom: 16px;

    &--last {
        margin-bottom: 0;
    }
}

// 分区标题
.section-title {
    color: #adadad;
    font-size: 12px;
    margin-bottom: 10px;
    font-weight: 400;
}

// 网格布局 - 每行3个
.menu-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

// 菜单项样式
.menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 32px;
    padding: 8px 10px;
    border-radius: 8px;
    color: #fff;
    text-decoration: none;
    transition: all 0.2s ease;
    cursor: pointer;
    background: transparent;
    border: none;
    text-align: left;
    white-space: nowrap;
    position: relative;

    &:hover {
        background: rgba(255, 255, 255, 0.05);
    }

    &--active {
        background: rgba(255, 255, 255, 0.05);
    }
}

// 图标样式
.menu-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    background-color: currentColor;
}

// 文字样式
.menu-text {
    font-size: 12px;
    line-height: 1;
    font-weight: 400;
}

// 勾选标记
.menu-check1 {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
}


// 图标样式 - 使用和 MobileTypeModal 一样的图标文件
.i-text-to-image-icon {
    mask: url('~/assets/images/menu/text-to-image.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/text-to-image.svg') no-repeat center;
    -webkit-mask-size: contain;
}

.i-image-to-image-icon {
    mask: url('~/assets/images/menu/img-to-img.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/img-to-img.svg') no-repeat center;
    -webkit-mask-size: contain;
}

.i-character-to-image-icon {
    mask: url('~/assets/images/menu/character-to-image.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/character-to-image.svg') no-repeat center;
    -webkit-mask-size: contain;
}

.i-photo-effects-icon {
    mask: url('~/assets/images/menu/photo-effects.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/photo-effects.png') no-repeat center;
    -webkit-mask-size: contain;
}

.i-ai-tool-icon {
    mask: url('~/assets/images/menu/ai-tools.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/ai-tools.png') no-repeat center;
    -webkit-mask-size: contain;
}

.i-text-to-video-icon {
    mask: url('~/assets/images/menu/text-to-video.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/text-to-video.svg') no-repeat center;
    -webkit-mask-size: contain;
}

.i-img-to-video-icon {
    mask: url('~/assets/images/menu/img-to-video.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/img-to-video.svg') no-repeat center;
    -webkit-mask-size: contain;
}

.i-video-to-video-icon {
    mask: url('~/assets/images/menu/video-to-video.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/video-to-video.svg') no-repeat center;
    -webkit-mask-size: contain;
}

.i-video-effects-icon {
    mask: url('~/assets/images/menu/video-effects.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/video-effects.png') no-repeat center;
    -webkit-mask-size: contain;
}

.i-ai-music-icon {
    mask: url('~/assets/images/menu/music.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/music.png') no-repeat center;
    -webkit-mask-size: contain;
}

.i-ai-image-icon {
    mask: url('~/assets/images/menu/image.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/image.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-generate-music-icon {
    mask: url('~/assets/images/menu/generate-music.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/generate-music.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}
</style>
